import ReactTableComponent from 'udesk-react/src/components/react-table/base';

export default function initialize() {
    Object.assign(ReactTableComponent.defaultProps, {
        freezeHeader: false,
    });
}